import { api } from "@/api";
import type { LayoutData } from "@/types/domain";

export const fetchLayoutData = async (): Promise<LayoutData> => {
  const response = await api.get<LayoutData>("/layout/Data");
  return response.data;
};
